export default "__VITE_ASSET__BTURrCtK__"